import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import tinymce from "vue-tinymce-editor";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
Vue.component("tinymce", tinymce);


Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css"
  ]
};
Vue.use(VueHtmlToPaper, options);




if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        console.log('Service worker registered.', reg);
      });
  });
}

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



const baseAPI = axios.create({
  baseURL: settings.apiURL,
});

const UNAUTHORIZED = 401;


Vue.mixin({
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 202) {
            return true;
          } else
            return false;
        });
    },
    GetInfoUser() {
      this.$API
        .get(this.$LoginUserDetail, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          console.log("t" + this.info);

          if (response.status == 200 && this.info != null) {
            this.Name = this.info.name;
            console.log("t" + this.info.name);
          
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    async tryLogin() {
      try {
          const formData = new FormData();
          formData.append("Email", "defaultuser@gmail.com");
          formData.append("Password", "Cellnet777#");
  
          const response = await this.$API.post(this.$LoginToken, formData,{ withCredentials: true });
          
          if (response.status === 200) {
            await this.GetInfoUser();
          } else {
              // Handle non-200 status here if needed
          }
      } catch (error) {
          this.Loading = false;
          this.Error = true;
          this.Message = error.response?.data?.message || 'An error occurred during login';
      }
  },
  
    // GoToLogin() {
    //   let path = this.$router.currentRoute.path;
    //   if (path.toLowerCase() != "/login") {

    //     this.$router.push({
    //       path: '/Login',
    //       query: {
    //         targetUrl: this.$router.currentRoute.fullPath,
    //       }
    //     })

    //   }
    // },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/Index");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/");
          }
        });

    },

    googleTranslateElementInit() {
      window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    },
  }

})

// baseAPI.interceptors.response.use(response => response, error => {
//   const {
//     status
//   } = error.response;
//   if (status == UNAUTHORIZED) {
//     router.push("/Login");
//   } else {
//     console.log("test");
//   }
//   return Promise.reject(error);
//   //
// })

baseAPI.interceptors.response.use(response => response, error => {
  const { status } = error.response;

  // Check if the status is UNAUTHORIZED
  if (status === UNAUTHORIZED) {
    // Check if the current page is not the home page before redirecting to login
    if (router.currentRoute.name !== 'Home') {  // Replace 'Home' with the actual name of your home page route
      router.push("/Login");
    }
  } else {
    console.log("test");
  }

  return Promise.reject(error);
});



Vue.prototype.$API = baseAPI

Vue.prototype.$uploadFile = 'aws/UploadVideoSessionIndex'
Vue.prototype.$UploadProfilePhoto = 'aws/UploadProfilePhoto'
Vue.prototype.$UploadBlog = 'aws/UploadBlog'
Vue.prototype.$UploadBlogFile = 'aws/UploadBlogFile'
Vue.prototype.$UploadAnyFile = 'aws/UploadAnyFile'
Vue.prototype.$UploadReceipt = 'aws/UploadReceipt'

//update
Vue.prototype.$DeleteSession = 'update/DeleteSession'
Vue.prototype.$UpdatePaymentPackage = 'update/UpdatePaymentPackage'
Vue.prototype.$UpdateCompanyView = 'update/UpdateCompanyView'
Vue.prototype.$CompanyDetail = 'update/CompanyDetails'
Vue.prototype.$UserDetails = 'update/UserDetails'
Vue.prototype.$ValidateEmail = 'update/VerifyEmail'
Vue.prototype.$UpdateComUpdateQuestionDetailpanyView = 'update/UpdateQuestionDetailCompanyView'
Vue.prototype.$UpdateDetailQuestionCode = 'update/UpdateDetailQuestionCode'
Vue.prototype.$UpdateBlog = 'update/UpdateBlog'
Vue.prototype.$UpdateUserCountry ='update/UpdateUserCountry'
Vue.prototype.$UpdateUserPoint ='update/ApproveUserPoint'



//insert
Vue.prototype.$Register = 'Insert/Register'
Vue.prototype.$RegisterQR = 'Insert/RegisterQR'
Vue.prototype.$LoginToken = 'Insert/LoginToken'
Vue.prototype.$LoginTokenQR = 'Insert/LoginTokenQR'
Vue.prototype.$UserAuth = 'Insert/IsAuthenticated'
Vue.prototype.$ExtractAudioText = 'insert/ExtractAudioText'
Vue.prototype.$ForgotPassword = 'insert/ForgotPassword'
Vue.prototype.$ValidateForgotPasswordCode = 'insert/ValidateForgotPasswordCode'
Vue.prototype.$ChangePassword = 'insert/ChangePassword'
Vue.prototype.$InsertSession = 'insert/SetSessionByToken'
Vue.prototype.$RegisterInterest = 'insert/RegisterInterest'
Vue.prototype.$RegisterSupport = 'insert/RegisterSupport'
Vue.prototype.$InsertQuestionGeneral = 'insert/InsertQuestionGeneral'
Vue.prototype.$InsertNextQuestion = 'insert/InsertNextQuestion'
Vue.prototype.$SubmitCompanyQuestion = 'insert/SubmitCompanyQuestion'
Vue.prototype.$InsertVoucher = 'insert/InsertVoucher'
Vue.prototype.$InsertShorlistedCandidate = 'insert/InsertShorlistedCandidate'
Vue.prototype.$ChangePasswordWoCode = 'insert/ChangePasswordWoCode'
Vue.prototype.$GenerateReport = 'insert/GenerateRank'
Vue.prototype.$SubmitFeedbacks = 'insert/AppFeedback'
Vue.prototype.$SubscribePackage = 'insert/SubscribePackages'
Vue.prototype.$SubscribePackagesFree = 'insert/SubscribePackagesFree'
Vue.prototype.$ForgotPassword = 'insert/ForgotPassword'
Vue.prototype.$ChangePassword = 'insert/ChangePassword'
Vue.prototype.$SignOut = 'insert/signout'
Vue.prototype.$RegisterSupport = 'insert/RegisterSupport'
Vue.prototype.$SetStatus = 'insert/SetStatus'
Vue.prototype.$EnterpriseContact = 'insert/EnterpriseContact'
Vue.prototype.$EvaluationCategory = 'insert/EvaluationCategory'
Vue.prototype.$StoreAnswerByText = 'insert/StoreAnswerByText'
Vue.prototype.$InsertConnectedUser = 'insert/InsertConnectedUser'
Vue.prototype.$InsertClaim = 'insert/RedeemVoucher'
Vue.prototype.$InsertClaimPoints = 'insert/UserRedeemCampaign'
Vue.prototype.$InsertUserPoint ='insert/InsertUserPoint'
Vue.prototype.$ApproveRedeemCampaigns ='update/ApproveRedeemCampaign'

//read
Vue.prototype.$LoginUserDetail = 'Read/UserDetail'
Vue.prototype.$UserDetailWoLogin = 'Read/UserDetailWoLogin'
Vue.prototype.$GetFirstQuestion = 'read/GetFirstQuestion'
Vue.prototype.$GetNextQuestion = 'read/GetNextQuestion'
Vue.prototype.$GetUserHistory = 'read/GetUserHistory'
Vue.prototype.$GetListPosition = 'read/GetListPosition'
Vue.prototype.$GetListCountries = 'read/getlistcountries'
Vue.prototype.$GetNextQuestionVideo = 'read/GetVideoDetails'
Vue.prototype.$GetListUserHistory = 'read/GetListUserHistory'
Vue.prototype.$GetListPackageCandidate = 'read/GetListPackageCandidate'
Vue.prototype.$GetListPackageCompany = 'read/GetListPackageCompany'
Vue.prototype.$GetSuccessPaymentSubscription = 'read/GetSuccessPackageSubscriptionByUser'
Vue.prototype.$GetListSuccessPackageSubscription = 'read/GetListSuccessPackageSubscription'
Vue.prototype.$GetRank = 'read/GetRank'
Vue.prototype.$GetlistUser = 'read/GetListUsers'
Vue.prototype.$GetListReportNotGenerate = 'read/GetListReportNotGenerate'
Vue.prototype.$GetPackageCandidateById = 'read/GetPackageById'
Vue.prototype.$GetListVoucher = 'read/GetListVoucher'
Vue.prototype.$GetListContactUs = 'read/GetContactUs'
Vue.prototype.$SessionSummary = 'read/SessionSummary'
Vue.prototype.$GetVoucherAmount = 'read/GetVoucherAmount'
Vue.prototype.$GetListUserNotListedShortlisted = 'read/GetListUserNotListedShortlisted'
Vue.prototype.$GetListUserListedShortlisted = 'read/GetListUserListedShortlisted'
Vue.prototype.$SubscribePackageByUser = 'read/SubscribePackageByUser'
Vue.prototype.$GetDetailTotalCandidate = 'read/GetDetailTotalCandidate'
Vue.prototype.$GetTotalCandidate = 'read/GetTotalCandidate'
Vue.prototype.$GetSessionUrl = 'read/GetSessionUrl'
Vue.prototype.$GetSessionId = 'read/GetSessionId'
Vue.prototype.$GetListCategoryJob = 'read/GetListCategoryJob'
Vue.prototype.$GetListCategoryJobType = 'read/GetListCategoryJobType'
Vue.prototype.$GetListCategoryJobSeniority = 'read/GetListCategoryJobSeniority'
Vue.prototype.$GetQuestionAnswer = 'read/GetQuestionAnswer'
Vue.prototype.$GetFirstQuestionByCode = 'read/GetFirstQuestionByCode'
Vue.prototype.$GetFirstQuestionByQrCode = 'read/GetFirstQuestionByQrCode'
Vue.prototype.$GetNextQuestionByCode = 'read/GetNextQuestionByCode'
Vue.prototype.$GetTokenEmail = 'Read/GetTokenEmail'
Vue.prototype.$GetListField = 'read/GetListField'
Vue.prototype.$GetListExpertise = 'read/GetListExpertise'
Vue.prototype.$ListVideo = 'read/ListVideo'
Vue.prototype.$VerifyCode = 'read/VerifyCode'
Vue.prototype.$ListCreatedQuestion = 'read/ListCreatedQuestion'
Vue.prototype.$ListCreatedQuestionByid = 'read/ListCreatedQuestionByid'
Vue.prototype.$ListPackage = 'read/ListPackage'
Vue.prototype.$ListVoucher = 'read/ListVoucher'
Vue.prototype.$CheckQuestionCompanyCode = 'read/CheckQuestionCompanyCode'
Vue.prototype.$ListCodeInterviewr = 'read/ListCodeInterviewr'
Vue.prototype.$ListStatus ='read/ListStatus'
Vue.prototype.$ListAllBlog ='read/ListAllBlog'
Vue.prototype.$BlogPostById ='read/BlogPostById'
Vue.prototype.$ListPublishBlog ='read/ListPublishBlog'
Vue.prototype.$GetSubscription ='read/GetSubscription'
Vue.prototype.$GetValueDashboard ='read/GetValueDashboard'
Vue.prototype.$CheckVideoSessionIndex= 'read/CheckVideoSessionIndex'
Vue.prototype.$DataEvaluation= 'read/DataEvaluation'
Vue.prototype.$DataEvalutionCompany='read/DataEvalutionCompany'
Vue.prototype.$GetGreeting='read/GetGreeting'
Vue.prototype.$GetVoucherByCode='read/GetVoucherByCode'
Vue.prototype.$ValidVoucher='read/ValidVoucher'
Vue.prototype.$CheckValidVoucherByCode='read/CheckValidVoucherByCode'
Vue.prototype.$GetDetailVoucherAllCompany='read/GetDetailVoucherAllCompany'
Vue.prototype.$GetListBrand='read/GetListBrandsCompany'
Vue.prototype.$GetListBrandVoucher='read/GetListVoucherCompany'
Vue.prototype.$GetListControlVoucherShow='read/GetListControlVoucherShow'
Vue.prototype.$GetListIndustries='read/GetListIndustries'
Vue.prototype.$GetDetailIndustries='read/GetDetailVoucherByIndustries'
Vue.prototype.$GetDetailVoucherPerIndustryAndCompany='read/GetDetailVoucherPerIndustryAndCompany'
Vue.prototype.$ListAppFeedback='read/ListAppFeedback'
Vue.prototype.$GetCountCustomerGrowth='read/GetCountCustomerGrowth'
Vue.prototype.$GetAllVoucherById='read/GetAllVoucherById'
Vue.prototype.$GetDetailVoucherPerCompany='read/GetDetailVoucherPerCompany'
Vue.prototype.$HistoryUserPoint='read/HistoryUserPoint'
Vue.prototype.$UserHisstoryLogs='read/UserHisstoryLogs'
Vue.prototype.$UserSummaryPoint='read/UserSummaryPoint'
Vue.prototype.$GetListCompanyCodePointAsyncNotApproved='read/GetListCompanyCodePointAsyncNotApproved'
Vue.prototype.$GetListRedeemCampaignNotApproved='read/GetListRedeemCampaignNotApproved'
Vue.prototype.$GetReceiptVoucherDetails='read/GetReceiptVoucherDetails'
Vue.prototype.$UserSummaryPointCompany='read/UserSummaryPointCompany'
Vue.prototype.$GetListUserDashboardPointAndRedeem='read/ListUserDashboardPointAndRedeem'


Vue.prototype.$DeleteCompanyQuestionCodeById = 'delete/DeleteCompanyQuestionCodeById'
Vue.prototype.$DeleteCompanyQuestion = 'delete/DeleteCompanyQuestion'
Vue.prototype.$DeleteBlogPost = 'delete/DeleteBlogPost'



new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App,
    PulseLoader,
  }
})
